module.exports = __webpack_public_path__ + "Icono_Buscar_Azul_126px.png";